import label from "@/lang/StaticLabels.js";
import { BOOTH_SUBSYSTEM_ID } from "@/config/subSystems.js";

// صفحات این ماژول هنوز پیاده‌سازی نشده‌اند و فعلاً صفحه «در حال توسعه» را نمایش می‌دهند.
// با پیاده‌سازی هر صفحه، component آن را با صفحه واقعی جایگزین کنید.
const PageUnderDevelopment = () =>
  import("@/views/modules/underDevelopment/Page.vue");

// PSTORE Router  - فروش فروشگاهی -----------------------------------------------
let routeItems = {
  path: "PSTORE",
  name: "PSTORE",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PSTOREDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PSTOREDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pstore,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pstore/Dashboard.vue"),
    },

    // عملیات فروشگاه  -----------------------------------------------
    {
      path: "preOrder",
      name: "PSTOREPreOrder",
      meta: {
        label: label.page.storePreOrder,
        requiresAuth: true,
        // زیرسیستم غرفه جدا خریداری می‌شود
        subSystemId: BOOTH_SUBSYSTEM_ID,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: { name: "PSTOREPreOrderList" },
      children: [
        {
          path: "list",
          name: "PSTOREPreOrderList",
          component: () =>
            import("@/views/modules/pstore/operation/preOrder/index.vue"),
          meta: {
            label: label.page.storePreOrder,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSTOREPreOrderAdd",
          component: () =>
            import("@/views/modules/pstore/operation/preOrder/Form.vue"),
          meta: {
            label: label.page.storeAddPreOrder,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSTOREPreOrderEdit",
          component: () =>
            import("@/views/modules/pstore/operation/preOrder/Form.vue"),
          meta: {
            label: label.page.storeEditPreOrder,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "quickSale",
      name: "PSTOREQuickSale",
      meta: {
        label: label.page.storeQuickSale,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-cash-register" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "saleReturn",
      name: "PSTORESaleReturn",
      meta: {
        label: label.page.storeSaleReturn,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-undo-variant" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "cashDesksAndBooths",
      name: "PSTORECashDesksAndBooths",
      meta: {
        label: label.page.storeCashDesksAndBooths,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-view-grid-outline" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "deliveryAndShipping",
      name: "PSTOREDeliveryAndShipping",
      meta: {
        label: label.page.storeDeliveryAndShipping,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-truck-delivery-outline" },
      },
      component: PageUnderDevelopment,
    },

    // مشتریان  -----------------------------------------------
    {
      path: "customerClub",
      name: "PSTORECustomerClub",
      meta: {
        label: label.page.storeCustomerClub,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-account-star-outline" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "afterSalesService",
      name: "PSTOREAfterSalesService",
      meta: {
        label: label.page.storeAfterSalesService,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-face-agent" },
      },
      component: PageUnderDevelopment,
    },

    // تعاریف و مدیریت  -----------------------------------------------
    // ثبت و ویرایش فروشگاه در مدال همین صفحه است
    {
      path: "store",
      name: "PSTOREStoreList",
      meta: {
        label: label.page.storeStores,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pstore/base/store/index.vue"),
    },
    {
      path: "booth",
      name: "PSTOREBooth",
      meta: {
        label: label.page.storeBooths,
        requiresAuth: true,
        // زیرسیستم غرفه جدا خریداری می‌شود
        subSystemId: BOOTH_SUBSYSTEM_ID,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: { name: "PSTOREBoothList" },
      children: [
        {
          path: "list",
          name: "PSTOREBoothList",
          component: () =>
            import("@/views/modules/pstore/base/booth/index.vue"),
          meta: {
            label: label.page.storeBooths,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSTOREBoothAdd",
          component: () =>
            import("@/views/modules/pstore/base/booth/Form.vue"),
          meta: {
            label: label.page.storeAddBooth,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSTOREBoothEdit",
          component: () =>
            import("@/views/modules/pstore/base/booth/Form.vue"),
          meta: {
            label: label.page.storeEditBooth,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "posTerminalTypes",
      name: "PSTOREPosTerminalTypes",
      meta: {
        label: label.page.storePosTerminalTypes,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pstore/base/posTerminal/index.vue"),
    },
    {
      path: "usersAndShifts",
      name: "PSTOREUsersAndShifts",
      meta: {
        label: label.page.storeUsersAndShifts,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-account-clock-outline" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "cashDesksAndTerminals",
      name: "PSTORECashDesksAndTerminals",
      meta: {
        label: label.page.storeCashDesksAndTerminals,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-point-of-sale" },
      },
      component: PageUnderDevelopment,
    },
    // همان صفحه چارت مسئولین فروش بازرگانی، داخل منوی فروشگاهی
    {
      path: "salesAgents",
      name: "PSTORESalesAgents",
      meta: {
        label: label.page.storeSalesAgents,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/psale/base/seller/index.vue"),
    },
    {
      path: "commissionPolicies",
      name: "PSTORECommissionPolicies",
      meta: {
        label: label.page.storeCommissionPolicies,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-percent-outline" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "pricesAndDiscounts",
      name: "PSTOREPricesAndDiscounts",
      meta: {
        label: label.page.storePricesAndDiscounts,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-tag-outline" },
      },
      component: PageUnderDevelopment,
    },
    {
      path: "salesReports",
      name: "PSTORESalesReports",
      meta: {
        label: label.page.storeSalesReports,
        requiresAuth: true,
        pageUnderDevelopment: { icon: "mdi-chart-bar" },
      },
      component: PageUnderDevelopment,
    },
    // تنظیمات زیرسیستم فروشگاهی و زیرسیستم غرفه (یک صفحه، نوع از meta)
    {
      path: "shopSetting",
      name: "PSTOREShopSetting",
      meta: {
        label: label.page.storeShopSetting,
        requiresAuth: true,
        settingType: "shop",
      },
      component: () => import("@/views/modules/pstore/base/setting/index.vue"),
    },
    {
      path: "boothSetting",
      name: "PSTOREBoothSetting",
      meta: {
        label: label.page.storeBoothSetting,
        requiresAuth: true,
        // زیرسیستم غرفه جدا خریداری می‌شود
        subSystemId: BOOTH_SUBSYSTEM_ID,
        settingType: "booth",
      },
      component: () => import("@/views/modules/pstore/base/setting/index.vue"),
    },
  ],
};

export default routeItems;
